// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"832159ba","455":"e2179e45","977":"a50aadc7"}[chunkId] + ".chunk.js";
};